// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface TerritoryHeaderProps {
  territories: unknown[];
  filterTerritory?: string;
  handleFilterTerritory: (e: unknown) => void;
}

function TerritoryHeader({
  territories,
  filterTerritory,
  handleFilterTerritory,
}: TerritoryHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="bulk-grid-game-name-th">
      <span className="mb-2">{t('Territory')}</span>
      <select
        className="form-control "
        value={filterTerritory || ''}
        onChange={handleFilterTerritory}
      >
        <option value="">{t('All')}</option>
        {territories
          ? [...territories]
              ?.sort((a, b) => a.name.localeCompare(b.name))
              .map((x) => (
                <option key={x.id} value={x.id}>
                  {x.name}
                </option>
              ))
          : ''}
      </select>
    </div>
  );
}

export default TerritoryHeader;
